import React from 'react';
import { injectIntl, InjectedIntl, FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import {
    VerificationService,
    ErrorId,
    ErrorResponse,
    PoweredByComponent,
} from '@sheerid/jslib';


interface StepErrorProps {
    verificationService: VerificationService;
    errorId?: ErrorId;
    intl?: InjectedIntl;
}

const StepError = ({ verificationService, errorId, intl }: StepErrorProps) => {
    const verificationResponse = verificationService.verificationResponse as ErrorResponse;
    const currentSegment = verificationResponse.segment;
    const limitExceededError = verificationResponse.errorIds.includes('verificationLimitExceeded');
    const errorTitle: FormattedMessage.Props =
        limitExceededError ?
        {
            id: 'limitExceededError',
            defaultMessage: 'Verification Limit Exceeded',
        } :
        {
            id: 'error',
            defaultMessage: 'Error',
        };

    const handleOnTryAgain = () => {
        verificationService.fetchNewVerificationRequest(verificationService.programId, currentSegment, verificationService.previousViewModel)
    }

    return (
        <div id="sid-step-error" className="sid-l-container">
            <div className="sid-header sid-l-horz-center">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage {...errorTitle} />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-space-top-md">
                    <img
                        className="sid-x"
                        alt="design element"
                        src="https://assets-resources.sheerid.com/targus/img/checkmark_red.png"
                    />
                    <div className="sid-error-msg sid-l-horz-center">
                        {errorId !== undefined
                            ? <FormattedHTMLMessage id={`errorId.${errorId}`} defaultMessage="Unknown Error" />
                            : null
                        }
                    </div>
                    <div className="sid-error-msg sid-l-horz-center">
                        {
                            verificationResponse.errorIds ?
                            (
                                <p>
                                    {
                                        verificationResponse.errorIds.map(
                                            errId => intl.formatMessage({ id: `errorId.${errId}`, defaultMessage: `${errId}` }),
                                        ).join(', ')
                                    }
                                </p>
                            )
                            : null
                        }
                    </div>
                    {!limitExceededError && (
                        <div className="sid-l-space-top-lg sid-l-half-width sid-l-horz-center">
                        </div>
                    )}
                </div>
            </div>

            <div className="sid-footer__one sid-l-horz-center sid-l-space-top-md">

                <FormattedHTMLMessage
                    id="step.error.either"
                    defaultMessage='Either '

                    />

                    <a href="javascript:;" onClick={ () => handleOnTryAgain()} className= "sid-link">
                        <FormattedHTMLMessage
                            id="step.error.tryAgain"
                            defaultMessage='try again '
                    /></a>

                 <FormattedHTMLMessage
                    id="step.error.contact"
                    defaultMessage='or contact your employee discount program administrator for further assistance.'
                    />
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-xl sid-h-small-text">
                <PoweredByComponent verificationService={verificationService} isCentered />
            </div>
        </div>
    );
};

export const StepErrorComponent = injectIntl(StepError);
